<template>
  <div class="container">
    <div class="text-end p-3">
      <c-primary-button to="/admin/configuraciones/semaforos/crear">
        Crear semáforo
      </c-primary-button>
    </div>
    <c-card title="Semáforos">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Semáforo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="semaforo in semaforos" :key="semaforo.id">
            <td>{{ semaforo.name }}</td>
            <td class="text-nowrap">
              <router-link
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                :to="`/admin/configuraciones/semaforos/${semaforo.id}/editar`"
                title="Editar"
                ><i class="fa-solid fa-pen"></i
              ></router-link>
              <a
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                href="javascript:void(0)"
                @click="deleteSemaforo(semaforo.id)"
                title="Eliminar"
                ><i class="fa-solid fa-trash-can"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
    </c-card>
  </div>
</template>
<script>
import CCard from "@/components/CCard.vue";
import CPrimaryButton from "@/components/CPrimaryButton.vue";
import { all, remove } from "@/services/semaforos";
import { showNotification } from "@/services/notification";

export default {
  components: {
    CCard,
    CPrimaryButton,
  },
  data() {
    return {
      semaforos: [],
    };
  },
  mounted() {
    this.getSemaforos();
  },
  methods: {
    getSemaforos() {
      all()
        .then((response) => {
          this.semaforos = response.data;
        })
        .catch(() => {
          alert("No pudimos cargar los semáforos");
        });
    },
    deleteSemaforo(id) {
      const removeRecord = confirm("¿Estás seguro de eliminar el registro?");
      if (!removeRecord) {
        return;
      }
      remove(id).then(() => {
        showNotification(204, "success", "El registro fue eliminado.");
        this.getSemaforos();
      });
    },
  },
};
</script>
